import { logNewRelic, logNewRelicPageAction, NrSpaApiEnum } from '@makemydeal/dr-activities-common';
import { getCustomerCardConfig } from '../config';

/**
 * Wraps logNewRelicPageAction so every customer-card PageAction automatically carries hostApp and
 * customerCardVariant, instead of each call site having to remember to pass them (and instead of a
 * global newrelic.setCustomAttribute, which would leak them onto unrelated events elsewhere on the page).
 */
export const logCustomerCardPageAction = (name: string, attributes: Record<string, unknown> = {}): void => {
    const config = getCustomerCardConfig();
    logNewRelicPageAction(name, {
        hostApp: config?.hostApp,
        customerCardVariant: config?.customerCardVariant,
        ...attributes
    });
};

/**
 * Wraps logCustomerCardPageAction with the `${hostApp}:InsuranceForm` action name that
 * shared-components' InsuranceForm.tsx already uses for ProvidersSearch/ProvidersSelect — so an
 * SCI session's events land as 'SCI:InsuranceForm', not lumped into MV's bucket. Falls back to the
 * plain 'InsuranceForm' name InsuranceForm.tsx itself uses when hostApp isn't configured.
 */
export const logCustomerCardInsuranceFormEvent = (attributes: Record<string, unknown>): void => {
    const hostApp = getCustomerCardConfig()?.hostApp;
    logCustomerCardPageAction(hostApp ? `${hostApp}:InsuranceForm` : 'InsuranceForm', attributes);
};

/**
 * Wraps logNewRelic(..., NrSpaApiEnum.ERROR). The underlying wrapper only supports a message string
 * (no structured attributes for noticeError), so hostApp/customerCardVariant are appended there — but
 * centralized here instead of hand-built per call site.
 */
export const logCustomerCardError = (name: string, value: string): void => {
    const config = getCustomerCardConfig();
    const hostApp = config?.hostApp ?? 'unknown';
    const customerCardVariant = config?.customerCardVariant ?? 'unknown';
    logNewRelic(name, `${value} (host: ${hostApp}, variant: ${customerCardVariant})`, NrSpaApiEnum.ERROR);
};
